/* eslint-disable react-hooks/rules-of-hooks */
// dataValidationTable.tsx
import { useEffect, useState } from 'react';
import { Typography, Button, Grid, Paper, TextField, Theme, Box } from '@mui/material';
import './styles.css'; // Import the CSS file
import { useDialog } from 'Contexts/Modals/ModalProvider';
import { ipayNet, newServer } from 'constants/constants';
import { useLogin } from 'Contexts/AuthProvider/AuthProvider';
import RequestBadges from './RequestBadges';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import ComputerIcon from '@mui/icons-material/Computer';
import DocumentIcon from '@mui/icons-material/Description';
import { Eye, EyeOff } from 'lucide-react';
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
interface data {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  attachmentUrl: string; // Add the appropriate type for attachment URL
  attachmentUrl2: string; // Add the appropriate type for attachment URL
  ipAddress: string;
  type: string;
  address1: string;
  address2: string;
  city: string;
  postalCode: string;
  // selectedBusinessType: string;
  businessName: string;
  userIdImgs: string[];
  doingBusinessAs: string;
  businessType: string;
  ein: string;
  ssn: string;
  website: string;
  phone: string;
  correlationId: string;
  businessClassification: string;
  state: string;
  dateOfBirth: string;
  industry: string;
  controller: {
    firstName: string;
    lastName: string;
    title: string;
    dateOfBirth: string;
    ssn: string;
    ownershipPercent: string;
    address: {
      address1: string;
      address2: string;
      city: string;
      stateProvinceRegion: string;
      postalCode: string;
      country: string;
    };
  };
  location: {
    city: string;
    country: string;
    state: string;
  };
  ip_address: string;
  browser: string;
}

// Hook de estilos personalizados

interface EditableInfoFieldProps {
  label: string;
  value: string;
  onSave: (value: string) => void | Promise<boolean | void>;
  dialogTitle: string;
  dialogDescription: string;
  placeholder: string;
  hrefKind?: 'url' | 'mailto';
}

const WEBSITE_URL_PATTERN =
  /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(#[-a-z\d_]*)?$/i;
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Propósito: Quita espacios y antepone https:// si el admin pegó solo el dominio.
 */
const normalizeWebsiteUrl = (rawUrl: string): string => {
  const trimmedUrl = (rawUrl || '').trim();
  if (!trimmedUrl) {
    /**
     * Output:
     * @returns string — Cadena vacía cuando no hay URL
     */
    return '';
  }

  /**
   * Output:
   * @returns string — URL con protocolo, lista para validar y persistir
   */
  return /^https?:\/\//i.test(trimmedUrl) ? trimmedUrl : `https://${trimmedUrl}`;
};

/**
 * Propósito: Decide si una URL de sitio es usable para aprobar el enrolamiento.
 */
const isValidWebsiteUrl = (rawUrl: string): boolean => {
  /**
   * Output:
   * @returns boolean — true si hay host con TLD (con o sin protocolo)
   */
  return WEBSITE_URL_PATTERN.test(normalizeWebsiteUrl(rawUrl));
};

/**
 * Propósito: Normaliza el email de KYC (trim + minúsculas) antes de validar y persistir.
 */
const normalizeEmail = (rawEmail: string): string => {
  /**
   * Output:
   * @returns string — Email recortado y en minúsculas
   */
  return (rawEmail || '').trim().toLowerCase();
};

/**
 * Propósito: Decide si el email de KYC es usable para create-merchant de USIO.
 */
const isValidEmail = (rawEmail: string): boolean => {
  /**
   * Output:
   * @returns boolean — true si tiene forma local@dominio.tld
   */
  return EMAIL_PATTERN.test(normalizeEmail(rawEmail));
};

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: theme.spacing(3),
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  textField: {
    marginBottom: theme.spacing(1),
  },
  button: {
    margin: theme.spacing(1, 0),
  },
}));

interface dataValidationTableProps {
  data: data;
  /** Fila cruda del listado, para mostrar el estado real de la solicitud. */
  request?: any;
  goBack: () => void;
}

const EnrollItem = ({ data, request, goBack }: dataValidationTableProps) => {
  const { openDialog } = useDialog();
  const [image1, setImage1] = useState<string>();
  const [image2, setImage2] = useState<string>();
  const [details, setDetails] = useState<string>();
  const [viewSSN, setViewSSN] = useState(false);
  const [webSite, setWebSite] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const handleViewSSN = () => {
    setViewSSN(!viewSSN);
  };
  const { user } = useLogin();
  const classes = useStyles();

  /**
   * Una solicitud diferida no tiene proveedor elegido: no hay nada que aprobar.
   * El backend lo rechaza con `ERROR_NO_PROVIDER_SELECTED`, asi que se evita
   * ofrecer los botones y se explica que falta.
   */
  const awaitingProvider = !request?.provider_choice;
  const paymentReady = request?.payment_ready === true;

  useEffect(() => {
    if (data.userIdImgs) {
      cargarImagenes();
    }
  }, []);

  useEffect(() => {
    setWebSite(data.website || '');
  }, [data.website]);

  useEffect(() => {
    setContactEmail(data.email || '');
  }, [data.email]);

  const cargarImagenes = async () => {
    try {
      const res = await fetch(`${newServer}aws/get-identification-request/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': ipayNet.apiToken,
          Authorization: `Bearer ${user?.token}`,
        },
      });

      const images: { imageUrls: string[] } = await res.json();

      for (let image of images.imageUrls) {
        const urlSinParametros = image.split('?')[0];

        const nombreArchivo1 = data.userIdImgs[0]?.split('/').pop();
        const nombreArchivo2 = data.userIdImgs[1]?.split('/').pop();

        if (nombreArchivo1 && urlSinParametros.includes(nombreArchivo1)) {
          setImage1(image);
        }
        if (nombreArchivo2 && urlSinParametros.includes(nombreArchivo2)) {
          setImage2(image);
        }
      }
    } catch (error) {
      console.log('cargarImagenes', error);
    }
  };

  /**
   * Handle request
   * @param status
   */
  const handleRequest = async (status: string) => {
    let acceptedStatus = 3;
    if (status === 'accept') {
      acceptedStatus = 2;
    }
    try {
      const res = await fetch(`${newServer}requests/status-internal/${data.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': ipayNet.apiToken,
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify({
          // El backend solo aplica el status de los proveedores que estan "en
          // juego", asi que mandar los dos es seguro (y sigue funcionando para
          // los requests que solo eligieron uno).
          status_dwolla: acceptedStatus,
          status_usio: acceptedStatus,
        }),
      });
      // `errorHandlerRoutes` responde texto plano, tanto en exito ("OK") como en error.
      const responseText = await res.text();
      if (responseText === 'OK') {
        goBack();
      } else {
        openDialog('information', null, {
          title: 'Error',
          description: 'The application could not be modified: ' + responseText,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Propósito: PUT de un campo de contacto (website/email) con rollback si falla.
   */
  const persistRequestContactField = async (
    endpoint: 'website' | 'email',
    payload: Record<string, unknown>,
    rollback: () => void,
    errorMessage: string,
  ): Promise<boolean> => {
    try {
      const res = await fetch(`${newServer}requests/${endpoint}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': ipayNet.apiToken,
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        /**
         * Output:
         * @returns true — Campo persistido; Approve puede usar el estado local
         */
        return true;
      }

      rollback();
      const responseText = await res.text();
      openDialog('information', null, {
        title: 'Error',
        description: responseText || errorMessage,
      });
      /**
       * Output:
       * @returns false — El PUT falló; se restauró el valor anterior
       */
      return false;
    } catch {
      rollback();
      openDialog('information', null, {
        title: 'Error',
        description: errorMessage,
      });
      /**
       * Output:
       * @returns false — Error de red; se restauró el valor anterior
       */
      return false;
    }
  };

  /**
   * Propósito: Confirma la aprobación usando website y email del estado local.
   * `data.website` / `data.email` son del listado al abrir el detalle: si el
   * admin acaba de editarlos, esos props quedan viejos hasta un refresh.
   */
  const handleApprove = () => {
    const websiteToValidate = normalizeWebsiteUrl(webSite || data.website || '');
    if (!isValidWebsiteUrl(websiteToValidate)) {
      /**
       * Output:
       * Side effects — Pide una URL válida; no llama al API de aprobación
       */
      openDialog('information', null, {
        title: 'Invalid Website URL',
        description: 'Please provide a valid website URL to proceed with the approval process.',
      });
      return;
    }

    const emailToValidate = normalizeEmail(contactEmail || data.email || '');
    if (!isValidEmail(emailToValidate)) {
      /**
       * Output:
       * Side effects — Pide un email válido; no llama al API de aprobación
       */
      openDialog('information', null, {
        title: 'Invalid Email',
        description: 'Please provide a valid email to proceed with the approval process.',
      });
      return;
    }

    /**
     * Output:
     * Side effects — Abre el diálogo de confirmación de aprobación
     */
    openDialog('information', null, {
      title: 'Approval Request',
      description: 'Are you sure you want to approve this request',
      cancelText: 'Cancel',
      onConfirm: () => handleRequest('accept'),
    });
  };

  /**
   * Propósito: Persiste la URL de website y actualiza el estado en caliente.
   * El update es optimista para que Approve vea el valor nuevo sin recargar.
   */
  const handleWebsiteUpdate = async (newUrl: string): Promise<boolean> => {
    const normalizedUrl = normalizeWebsiteUrl(newUrl);
    if (!isValidWebsiteUrl(normalizedUrl)) {
      /**
       * Output:
       * @returns false — URL inválida; el diálogo de edición permanece abierto
       */
      openDialog('information', null, {
        title: 'Error',
        description: 'The URL is not valid',
      });
      return false;
    }

    const previousUrl = webSite;
    setWebSite(normalizedUrl);
    /**
     * Output:
     * @returns boolean — true si el PUT de website se guardó
     */
    return persistRequestContactField(
      'website',
      { website: normalizedUrl, id: data.id },
      () => setWebSite(previousUrl),
      'The website URL could not be saved. Please try again.',
    );
  };

  /**
   * Propósito: Persiste el email de KYC (info_dwolla + info_usio) en caliente
   * para que Approve/create-merchant use el correo nuevo sin recargar.
   */
  const handleEmailUpdate = async (newEmail: string): Promise<boolean> => {
    const normalizedEmail = normalizeEmail(newEmail);
    if (!isValidEmail(normalizedEmail)) {
      /**
       * Output:
       * @returns false — Email inválido; el diálogo de edición permanece abierto
       */
      openDialog('information', null, {
        title: 'Error',
        description: 'The email is not valid',
      });
      return false;
    }

    const previousEmail = contactEmail;
    setContactEmail(normalizedEmail);
    /**
     * Output:
     * @returns boolean — true si el PUT de email se guardó
     */
    return persistRequestContactField(
      'email',
      { email: normalizedEmail, id: data.id },
      () => setContactEmail(previousEmail),
      'The email could not be saved. Please try again.',
    );
  };

  /**
   * Handle deny
   */
  const handleDeny = () => {
    openDialog('information', null, {
      title: 'Deny Request',
      input: details,
      setInput: (value: string) => setDetails(value as any),
      inputPlaceholder: 'Please provide a reason for the denial',
      description: 'Are you sure you want to deny this request',
      cancelText: 'Cancel',
      onConfirm: () => handleRequest('deny'),
      isMultiline: true,
    });
  };

  return (
    <Box className='min-h-screen bg-background p-4'>
      <Box className='max-w-7xl mx-auto'>
        <Button
          onClick={goBack}
          /**
           * Se quitaron `text-primary hover:text-primary-hover`. El tema ya
           * pinta los botones de texto con `--brand-text` (legible), y el
           * `hover` apuntaba a `--brand-hover`, que sobre la superficie se
           * queda en 3.4:1. Con las clases fuera no hay dos reglas peleando
           * por el mismo color.
           */
          className='mb-4'
          startIcon={<ArrowBackIcon />}
        >
          Back
        </Button>

        {data && (
          <Grid container spacing={3}>
            {/* Left Column - Information */}
            <Grid item xs={12} lg={7}>
              <Paper className='rounded-lg shadow-xl p-6 h-full'>
                {/* Estado real de la solicitud: proveedor, origen y si ya puede cobrar. */}
                <Box className='mb-6'>
                  <RequestBadges
                    request={request}
                    size='medium'
                  />
                </Box>

                {awaitingProvider && (
                  <Typography variant='body2' className='text-foreground-muted mb-4'>
                    This applicant has not chosen a payment provider yet, so there is nothing to
                    approve. They can finish setting it up from their portal, and this request will
                    update automatically.
                  </Typography>
                )}

                {paymentReady && (
                  <Typography variant='body2' className='text-foreground-muted mb-4'>
                    This account is already approved and can collect payments.
                  </Typography>
                )}

                {/* Personal Information */}
                <Box className='mb-8 '>
                  <Box className='flex items-center gap-2 mb-4 text-primary-text border-b border-border pb-2'>
                    <PersonIcon />
                    <Typography variant='h6' className='text-primary-text'>
                      Personal Information
                    </Typography>
                  </Box>
                  <Grid container spacing={2}>
                    <InfoField label='Name' value={`${data.firstName} ${data.lastName}`} />
                    <EditableInfoField
                      label='Email'
                      value={contactEmail}
                      onSave={handleEmailUpdate}
                      dialogTitle='Edit Email'
                      dialogDescription='If this email is already registered with USIO, enter a different one so the application can be approved:'
                      placeholder='Enter new email'
                      hrefKind='mailto'
                    />
                    <InfoField label='Phone' value={data.phone} />
                    <InfoField label='Date of Birth' value={data.dateOfBirth} />
                  </Grid>
                </Box>

                {/* Business Information */}
                <Box className='mb-8'>
                  <Box className='flex items-center gap-2 mb-4 text-primary-text border-b border-border pb-2'>
                    <BusinessIcon />
                    <Typography variant='h6' className='text-primary-text'>
                      Business Information
                    </Typography>
                  </Box>
                  <Grid container spacing={2}>
                    <InfoField label='Business Name' value={data.businessName} />
                    <InfoField label='Business Type' value={data.businessType} />
                    {/* En las diferidas no hay EIN: sin la guarda, `slice` lanzaba TypeError. */}
                    <InfoField
                      label='EIN'
                      value={data.ein ? `****${data.ein.slice(-4)}` : 'Not provided'}
                      fullValue={data.ein}
                      isProtected
                    />

                    <EditableInfoField
                      label='Website'
                      value={webSite}
                      onSave={handleWebsiteUpdate}
                      dialogTitle='Edit Website URL'
                      dialogDescription='Please provide the new URL for the website below:'
                      placeholder='Enter new URL'
                      hrefKind='url'
                    />
                  </Grid>
                </Box>

                {/* System Information */}

                {/* Controller Information */}
                {data.controller && (
                  <Box>
                    <Box className='flex items-center gap-2 mb-4 text-primary-text border-b border-border pb-2'>
                      <PersonIcon />
                      <Typography variant='h6' className='text-primary-text'>
                        Controller Information
                      </Typography>
                    </Box>
                    <Grid container spacing={2}>
                      <InfoField
                        label='Name'
                        value={`${data.controller.firstName} ${data.controller.lastName}`}
                      />
                      <InfoField label='Title' value={data.controller.title} />
                      <InfoField label='Date of Birth' value={data.controller.dateOfBirth} />

                      {/* En las diferidas no hay SSN: sin la guarda, `slice` lanzaba TypeError. */}
                      <InfoField
                        label='SSN'
                        value={
                          data.controller.ssn
                            ? `****${data.controller.ssn.slice(-4)}`
                            : 'Not provided'
                        }
                        fullValue={data.controller.ssn}
                        isProtected
                      />
                    </Grid>
                  </Box>
                )}
                <Box className='mb-2 mt-8'>
                  <Box className='flex items-center gap-2 mb-4 text-primary-text border-b border-border pb-2'>
                    <ComputerIcon />
                    <Typography variant='h6' className='text-primary-text'>
                      System Information
                    </Typography>
                  </Box>
                  <Grid container spacing={2}>
                    <InfoField label='IP Address' value={data.ip_address} />
                    <InfoField
                      label='Location'
                      value={`${data.location?.city}, ${data.location?.state}, ${data.location?.country}`}
                    />
                    <InfoField label='Browser' value={data.browser} />
                  </Grid>
                </Box>
              </Paper>
            </Grid>

            {/* Right Column - Documents */}
            <Grid item xs={12} lg={5}>
              <Paper className='rounded-lg shadow-xl p-6 h-full'>
                <Box className='flex items-center gap-2 mb-4 text-primary-text border-b border-border pb-2'>
                  <DocumentIcon />
                  <Typography variant='h6' className='text-primary-text'>
                    Documents
                  </Typography>
                </Box>
                <Box className='space-y-4'>
                  {image1 && (
                    <Box className='relative group'>
                      <img
                        src={image1}
                        alt='Document 1'
                        className='w-full h-auto rounded-lg shadow-lg cursor-pointer transition-all duration-300 hover:shadow-2xl'
                        onClick={() => window.open(image1, '_blank')}
                      />
                      <Box className='absolute inset-0 bg-surface-overlay opacity-0 group-hover:opacity-20 transition-all duration-300 rounded-lg' />
                    </Box>
                  )}
                  {image2 && (
                    <Box className='relative group mt-4'>
                      <img
                        src={image2}
                        alt='Document 2'
                        className='w-full h-auto rounded-lg shadow-lg cursor-pointer transition-all duration-300 hover:shadow-2xl'
                        onClick={() => window.open(image2, '_blank')}
                      />
                      <Box className='absolute inset-0 bg-surface-overlay opacity-0 group-hover:opacity-20 transition-all duration-300 rounded-lg' />
                    </Box>
                  )}
                </Box>
              </Paper>
            </Grid>

            {/* Action Buttons */}
            <Grid item xs={12}>
              <Paper sx={{ backgroundColor: 'transparent' }} className='rounded-lg shadow-xl p-4'>
                <Box className='flex justify-end gap-4'>
                  {/*
                    `sx={{ backgroundColor: 'green' }}` y los `bg-green-600` de
                    Tailwind eran dos verdes distintos, ambos literales y fuera
                    del tema. `color='success'` toma `success.main` de los
                    tokens, que ademas cambia de tono en modo claro para pasar
                    contraste. Aprobar/denegar conservan su semantica.
                  */}
                  <Button
                    color='success'
                    variant='contained'
                    onClick={handleApprove}
                    // Sin proveedor elegido no hay nada que aprobar: el backend
                    // responde 400 y antes el boton parecia funcionar.
                    disabled={awaitingProvider}
                    className='px-8'
                  >
                    Approve
                  </Button>
                  <Button
                    color='error'
                    variant='contained'
                    onClick={handleDeny}
                    disabled={awaitingProvider}
                    className='px-8'
                  >
                    Deny
                  </Button>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        )}
      </Box>
    </Box>
  );
};
interface InfoFieldProps {
  label: string;
  value: string | JSX.Element;
  fullValue?: string;
  isProtected?: boolean;
}

const InfoField = ({ label, value, fullValue, isProtected = false }: InfoFieldProps) => {
  const [showFull, setShowFull] = useState(false);

  return (
    <Grid container item xs={12} sm={6} className='text-foreground' alignItems='center'>
      <Grid className='mr-4' item>
        <Typography className='font-bold'>{label}:</Typography>
      </Grid>
      <Grid item>
        <Typography className='mr-4 text-foreground-muted'>
          {isProtected ? (showFull ? fullValue : value) : value}
        </Typography>
      </Grid>
      {isProtected && (
        <Grid item>
          <button
            onClick={() => setShowFull(!showFull)}
            className='min-w-[40px] bg-transparent h-[40px] p-2 rounded-full flex items-center justify-center'
          >
            {showFull ? (
              <EyeOff className='hover:text-success text-foreground' size={18} />
            ) : (
              <Eye className='hover:text-success text-foreground' size={18} />
            )}
          </button>
        </Grid>
      )}
    </Grid>
  );
};
const EditableInfoField: React.FC<EditableInfoFieldProps> = ({
  label,
  value,
  onSave,
  dialogTitle,
  dialogDescription,
  placeholder,
  hrefKind = 'url',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [editValue, setEditValue] = useState('');
  const displayHref = hrefKind === 'mailto' ? `mailto:${value}` : value;

  const handleOpen = () => {
    setEditValue(value);
    setIsOpen(true);
  };

  /**
   * Propósito: Guarda el valor editado y cierra el diálogo solo si el padre confirma.
   */
  const handleSave = async () => {
    const saved = await onSave(editValue);
    if (saved === false) {
      /**
       * Output:
       * Side effects — El valor no se guardó; el diálogo sigue abierto
       */
      return;
    }
    /**
     * Output:
     * Side effects — Cierra el diálogo; el padre ya tiene el valor nuevo
     */
    setIsOpen(false);
  };

  return (
    <Grid container item xs={12} sm={6} className='text-foreground' alignItems='center'>
      <Grid>
        <Typography className='font-bold'>{label}:</Typography>
      </Grid>
      <Grid className='ml-4' item>
        <a
          href={displayHref}
          target={hrefKind === 'url' ? '_blank' : undefined}
          rel={hrefKind === 'url' ? 'noopener noreferrer' : undefined}
          style={{ color: 'var(--brand)', textDecoration: 'none', fontSize: '18px' }}
        >
          {value}
        </a>
      </Grid>

      <IconButton size='small' onClick={handleOpen}>
        <EditIcon fontSize='small' style={{ color: 'var(--text-muted)' }} />
      </IconButton>

      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        fullWidth
        maxWidth='sm'
        PaperProps={{
          style: {
            borderRadius: 'var(--radius)',
            padding: '16px',
          },
        }}
      >
        <DialogTitle>
          <Typography variant='h6' fontWeight='bold' align='center' color='text.primary'>
            {dialogTitle}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography
            variant='body2'
            align='center'
            color='text.secondary'
            style={{ marginBottom: '12px' }}
          >
            {dialogDescription}
          </Typography>
          <TextField
            fullWidth
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
            placeholder={placeholder}
            margin='dense'
            variant='outlined'
            type={hrefKind === 'mailto' ? 'email' : 'text'}
          />
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center', gap: '8px' }}>
          <Button variant='outlined' onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
          <Button onClick={handleSave} variant='contained'>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default EnrollItem;
